import { Controller } from 'stimulus'
import throttle from 'lodash/throttle'
import { enableScroll, disableScroll } from '../../_js/utils/prevent-scroll'

import { BREAKPOINTS } from '../../_js/base/consts'

export default class ReleasesController extends Controller {
  static targets = ['versionPicker', 'heroSection', 'heroPickerBar']

  static values = {
    versionPickerHiddenClass: String,
  }

  static sectionObserver

  toggleBodyScroll() {
    const isMobile = window.innerWidth < BREAKPOINTS.VIEWPORT_M
    const isPickerOpen = this.versionPickerTarget.classList.contains(this.versionPickerHiddenClassValue)

    if (isMobile) {
      if (!isPickerOpen) {
        disableScroll(document.body)
      } else {
        enableScroll(document.body)
      }
    }
  }

  toggleVersionPicker() {
    this.versionPickerTarget.classList.toggle(this.versionPickerHiddenClassValue)
    this.toggleBodyScroll()
  }

  handleGlobalClicks({ target }) {
    this.smartCloseVersionPicker(target)
  }

  smartCloseVersionPicker(target) {
    if (target.classList.contains('hero__picker-button')) {
      return
    }

    const isVersionPickerOpen = !this.versionPickerTarget.classList.contains(this.versionPickerHiddenClassValue)
    const isMobile = window.innerWidth < BREAKPOINTS.VIEWPORT_M

    const isClickOnVersionPicker = !!target.closest('.hero__version-picker')
    const isClickOnBackdrop = target.closest('.hero__version-picker') === target

    if ((isVersionPickerOpen && !isClickOnVersionPicker) || (isMobile && isClickOnBackdrop)) {
      this.toggleVersionPicker()
    }
  }
}
